export default __webpack_public_path__ + "static/media/email.af4b4221.svg";